import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

interface RestrictVendorRouteProps {
  children: React.ReactNode;
}

const RestrictVendorRoute = ({ children }: RestrictVendorRouteProps) => {
  const vendor = useSelector((state: RootState) => state.vendor.vendor);


  if (vendor?._id) {
    return <Navigate to="/app/inbox" replace />;
  }

  return <>{children}</>;
};

export default RestrictVendorRoute;